import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import './assets/scss/global.scss'
import { routes } from 'router'
import QueryProvider from 'shared/components/queryClient'
import ModalProvider from 'shared/components/modalProvider'
import Toaster from 'shared/components/toaster'

function App() {
  return (
    <>
      <QueryProvider>
        {(queryClient) => (
          <>
            <Suspense fallback={null}>
              <RouterProvider router={routes(queryClient)} />
            </Suspense>
            <Suspense fallback={null}>
              <ModalProvider />
            </Suspense>
            <Suspense>
              <Toaster />
            </Suspense>
          </>
        )}
      </QueryProvider>
    </>
  )
}

export default App
